export const SOCIAL_PLATFORMS = [
    { key: 'facebook', label: 'Facebook', prefix: 'https://www.facebook.com/', display: 'facebook.com/' },
    { key: 'instagram', label: 'Instagram', prefix: 'https://www.instagram.com/', display: 'instagram.com/' },
    { key: 'x', label: 'X', prefix: 'https://x.com/', display: 'x.com/' },
    {
        key: 'linkedIn',
        label: 'LinkedIn',
        prefix: 'https://www.linkedin.com/company/',
        display: 'linkedin.com/company/',
    },
    { key: 'pinterest', label: 'Pinterest', prefix: 'https://www.pinterest.com/', display: 'pinterest.com/' },
    {
        key: 'youTube',
        label: 'YouTube',
        prefix: 'https://www.youtube.com/',
        display: 'youtube.com/',
        keepLeadingAt: true,
    },
    { key: 'tikTok', label: 'TikTok', prefix: 'https://www.tiktok.com/@', display: 'tiktok.com/@' },
];

const capitalize = value => value.charAt(0).toUpperCase() + value.slice(1);

// Per-platform bulk-edit descriptors: a form field name + the matching server LocationField enum name
// (e.g. facebook -> socialFacebook / 'SocialFacebook'). Keeps the bulk option list and the request mapper
// derived from the single SOCIAL_PLATFORMS source.
export const SOCIAL_BULK_FIELDS = SOCIAL_PLATFORMS.map(platform => ({
    ...platform,
    fieldValue: `social${capitalize(platform.key)}`,
    enumName: `Social${capitalize(platform.key)}`,
}));

const SCHEME_OR_WWW = /^(?:https?:\/\/)?(?:www\.)?/i;

export const looksLikeUrl = value => /^(https?:)?\/\//i.test(value) || /^[a-z0-9-]+(\.[a-z0-9-]+)+\//i.test(value);

// An empty value is allowed (the platform simply isn't set); a non-empty value must be a scheme-prefixed
// URL with no whitespace. Mirrors the Yup .url() guard the manage-location form applies to these fields,
// for the bulk form which has no form-level resolver.
export const isValidSocialUrl = value => !value || /^https?:\/\/[^\s]+$/i.test(value);

export const ensureScheme = value => {
    if (/^https?:\/\//i.test(value)) return value;
    if (value.startsWith('//')) return `https:${value}`;
    return `https://${value}`;
};

export const stripPrefix = (value, display) => {
    if (!value) return { suffix: '', matched: true };
    const comparable = value.replace(SCHEME_OR_WWW, '');
    if (comparable.toLowerCase().startsWith(display.toLowerCase())) {
        return { suffix: comparable.slice(display.length), matched: true };
    }
    return { suffix: value, matched: false };
};

export const resolveSocialLinkValue = (rawInput, { prefix, display, keepLeadingAt }) => {
    const value = (rawInput || '').trim();
    if (!value) return '';

    const comparable = value.replace(SCHEME_OR_WWW, '');
    const displayLower = display.toLowerCase();
    const stripAt = handle => (keepLeadingAt ? handle : handle.replace(/^@+/, ''));

    if (comparable.toLowerCase().startsWith(displayLower)) {
        let rest = comparable;
        while (rest.toLowerCase().startsWith(displayLower)) {
            rest = rest.slice(display.length).replace(SCHEME_OR_WWW, '');
        }
        const handle = stripAt(rest);
        return handle ? prefix + handle : '';
    }

    if (comparable.toLowerCase() === displayLower.replace(/\/.*$/, '')) return '';

    if (looksLikeUrl(value)) return ensureScheme(value);

    const handle = stripAt(value);
    return handle ? prefix + handle : '';
};
